document.addEventListener('DOMContentLoaded', function () {

    document.addEventListener('click', function(event) {
        const carLink = event.target.closest('.car-link');

        if (carLink) {
            if (carLink.dataset.disableBackLink === "true") return;

            const currentUrl = window.location.href;
            const scrollY = window.scrollY;
            localStorage.setItem('advertisementReturnLink', currentUrl);
            localStorage.setItem('advertisementReturnScroll', scrollY);
        }
    });

    const backButton = document.getElementById('back-button');
    if (backButton) {
        backButton.addEventListener('click', function(event) {
            event.preventDefault();

            const defaultBackUrl = event.currentTarget.dataset.defaultBackUrl;
            const backUrl = localStorage.getItem('advertisementReturnLink');

            if (backUrl) {
                localStorage.setItem('advertisementShouldRestoreScroll', 'true');
                window.location.href = backUrl;
            } else {
                window.location.href = defaultBackUrl;
            }
        });
    }

    const shouldRestore = localStorage.getItem('advertisementShouldRestoreScroll');
    if (shouldRestore === 'true') {
        localStorage.removeItem('advertisementShouldRestoreScroll');

        const scrollY = parseInt(localStorage.getItem('advertisementReturnScroll'), 10);
        if (!isNaN(scrollY)) {
            setTimeout(() => window.scrollTo(0, scrollY), 50);
        }

        // localStorage.removeItem('advertisementReturnLink');
        // localStorage.removeItem('advertisementReturnScroll');
    }
});